import { IconArrowLeft } from "../../../../../../../../components/Icon/Icon";
import { FormattedMessage } from "react-intl";
import { DEFAULT_HISTORY_LENGTH_WHEN_NOT_NAVIGATED } from "app/utils/const";
import { useHistory } from "react-router-dom";
import "./BackButton.scss";

interface BackButtonProps {
  fallbackUrl?: string;
}

export default function BackButton({
  fallbackUrl = "/events",
}: BackButtonProps) {
  const history = useHistory();

  // Check if the user can go back in history. To know if the user navigated through
  // the app's navigation or directly to an event page.
  const canGoBack = () => {
    console.debug("window.history.length", window.history.length);
    return window.history.length > DEFAULT_HISTORY_LENGTH_WHEN_NOT_NAVIGATED;
  };

  const handleBackNavigation = () => {
    // Use cases:
    // 1. If the user navigated through the app's navigation, just go back.
    // 2. If the user landed directly redirectly to the custom URL.
    if (canGoBack()) {
      history.goBack();
    } else {
      history.push(fallbackUrl);
    }
  };
  return (
    <a
      className="back-button"
      onClick={handleBackNavigation}
      aria-label="Go back"
    >
      <IconArrowLeft />
      <FormattedMessage
        tagName="span"
        id="global-events-navigation-all-events"
      />
    </a>
  );
}
